import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type SyncStatus = 'idle' | 'syncing' | 'success' | 'error'

export interface OfflineState {
  isOnline: boolean
  pendingCount: number
  syncStatus: SyncStatus
  lastSyncAt: string | null
  syncError: string | null
  hasCachedData: boolean
}

const initialState: OfflineState = {
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  pendingCount: 0,
  syncStatus: 'idle',
  lastSyncAt: null,
  syncError: null,
  hasCachedData: false,
}

const offlineSlice = createSlice({
  name: 'offline',
  initialState,
  reducers: {
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload
    },
    setPendingCount: (state, action: PayloadAction<number>) => {
      state.pendingCount = action.payload
    },
    incrementPending: (state) => {
      state.pendingCount += 1
    },
    decrementPending: (state) => {
      state.pendingCount = Math.max(0, state.pendingCount - 1)
    },
    setSyncStatus: (state, action: PayloadAction<SyncStatus>) => {
      state.syncStatus = action.payload
      if (action.payload === 'error') {
        // keep syncError set externally
      } else {
        state.syncError = null
      }
    },
    setSyncSuccess: (state) => {
      state.syncStatus = 'success'
      state.lastSyncAt = new Date().toISOString()
      state.pendingCount = 0
      state.syncError = null
    },
    setSyncError: (state, action: PayloadAction<string>) => {
      state.syncStatus = 'error'
      state.syncError = action.payload
    },
    setHasCachedData: (state, action: PayloadAction<boolean>) => {
      state.hasCachedData = action.payload
    },
  },
})

export const {
  setOnlineStatus,
  setPendingCount,
  incrementPending,
  decrementPending,
  setSyncStatus,
  setSyncSuccess,
  setSyncError,
  setHasCachedData,
} = offlineSlice.actions

export default offlineSlice.reducer
